import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "dataForm" }
const _hoisted_2 = {
  key: 0,
  class: "approval-form-title"
}
const _hoisted_3 = { class: "underlineForm" }
const _hoisted_4 = {
  key: 0,
  class: "mb-20 fullWidth"
}
const _hoisted_5 = {
  key: 1,
  class: "dialog-footer mt-20"
}
const _hoisted_6 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ZUpload = _resolveComponent("ZUpload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_BusinessList = _resolveComponent("BusinessList")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'approval' && _ctx.approvalTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.approvalTitle), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      ref: "dataForm",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "100px",
      class: "mb-20",
      disabled: _ctx.mode === 'approval'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, {
            label: "客户订单号",
            prop: "customerNo",
            class: _normalizeClass({ 'is-approval-diff': _ctx.isFieldDiff('customerNo') })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.customerNo,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.customerNo) = $event)),
                type: "input",
                class: "filter-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_form_item, {
            label: "客户公司名称",
            prop: "customerCompanyId",
            class: _normalizeClass({ 'is-approval-diff': _ctx.isFieldDiff('customerCompanyId') })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.customerCompanyId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.customerCompanyId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.companyRemoteMethod(''))),
                "remote-method": query => _ctx.companyRemoteMethod(query)
              }, {
                default: _withCtx(() => [
                  (_ctx.companyOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.companyOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id,
                          disabled: item.disable
                        }, null, 8, ["label", "value", "disabled"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_form_item, {
            label: "所属公司",
            prop: "titleId",
            class: _normalizeClass({ 'is-approval-diff': _ctx.isFieldDiff('titleId') })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.titleId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.titleId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                "remote-method": _ctx.getTitleOptionRemote,
                onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getTitleOptionRemote(''))),
                onChange: _ctx.handleCompanyTitleChange
              }, {
                default: _withCtx(() => [
                  (_ctx.titleOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.titleOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method", "onChange"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_form_item, {
            label: "税率",
            prop: "taxRate",
            class: _normalizeClass({ 'is-approval-diff': _ctx.isFieldDiff('taxRate') })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.taxRate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.taxRate) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                onChange: _ctx.handleCalcTotal
              }, {
                default: _withCtx(() => [
                  (_ctx.taxRateList.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.taxRateList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item + '%',
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_form_item, {
            label: "订单图片",
            prop: "pictures",
            class: _normalizeClass(["fullWidth", { 'is-approval-diff': _ctx.isFieldDiff('pictures') }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ZUpload, {
                onChanged: _ctx.handleUploadChange,
                value: _ctx.ruleForm.pictures,
                option: { config: {} },
                accept: ".pdf,.jpeg,.jpg,.png,.webp"
              }, null, 8, ["onChanged", "value"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "mark",
            class: _normalizeClass(["fullWidth", { 'is-approval-diff': _ctx.isFieldDiff('mark') }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.mark,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.mark) = $event)),
                type: "textarea",
                class: "filter-item",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["class"]),
          (_ctx.mode !== 'approval')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_el_button, {
                  onClick: _ctx.handleAddBusinessComand,
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" 添加业务 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: _ctx.removeBusiness }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode(" 移除业务 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.mode !== 'approval')
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 1,
                data: _ctx.ruleForm.details,
                border: "",
                fit: "",
                "row-key": "id",
                class: "fullWidth",
                "summary-method": _ctx.getSummaries,
                "show-summary": "",
                "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
                onSelectionChange: _ctx.handleTableSelect
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    width: "55"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "no",
                    label: "业务编号",
                    width: "150"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "业务名称",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "brand",
                    label: "业务品牌",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "model",
                    label: "型号",
                    width: "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "serial",
                    label: "序列号",
                    width: "130"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "amount",
                    label: "数量",
                    width: "70"
                  }),
                  (_ctx.ruleForm.taxRate)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_table_column, {
                          prop: "price",
                          label: "单价(含税)",
                          width: "160"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_input_number, {
                              modelValue: row.price,
                              "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                              type: "number",
                              onInput: _ctx.handleCalcTotal,
                              precision: 2,
                              "controls-position": "right"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "priceWithRate",
                          label: "单价(未税)",
                          "min-width": "90",
                          align: "right"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.priceWithoutRate(row.price, row.amount, true)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "totalPrice",
                          label: "总价(含税)",
                          "min-width": "90",
                          align: "right"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.price, row.amount, true)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "totalPriceWithRate",
                          label: "总价(未税)",
                          "min-width": "90",
                          align: "right"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.totalPriceWithoutRate(row.price, row.amount, true)), 1)
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_table_column, {
                          prop: "price",
                          label: "单价",
                          "min-width": "160"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_input_number, {
                              modelValue: row.price,
                              "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                              type: "number",
                              precision: 2,
                              "controls-position": "right"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "totalPrice",
                          label: "总价(RNB)",
                          "min-width": "90",
                          align: "right"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.price, row.amount, true)), 1)
                          ]),
                          _: 1
                        })
                      ], 64))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "onSelectionChange"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["model", "rules", "disabled"]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "approval", {}, undefined, true)
    ]),
    (_ctx.mode !== 'approval')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.submitLoading,
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.dialogVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "业务列表",
          width: "80%",
          "before-close": _ctx.handleClose
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_el_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible = false))
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.addBusiness
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_BusinessList, {
              mode: "table",
              ref: "BusinessList",
              customerCompanyId: _ctx.ruleForm.customerCompanyId,
              excludeIds: _ctx.getexcludeIds(),
              pageType: "ORDER"
            }, null, 8, ["customerCompanyId", "excludeIds"])
          ]),
          _: 1
        }, 8, ["modelValue", "before-close"]))
      : _createCommentVNode("", true)
  ]))
}